import { render, staticRenderFns } from "./AufgabenComponentAufgabeRueckmeldung.vue?vue&type=template&id=b25434e0&scoped=true"
import script from "./AufgabenComponentAufgabeRueckmeldung.vue?vue&type=script&lang=js"
export * from "./AufgabenComponentAufgabeRueckmeldung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25434e0",
  null
  
)

export default component.exports